import React, { createContext, useContext, useState } from "react";

const ErrorContext = createContext();

export const ErrorProvider = ({ children }) => {
  const [globalError, setGlobalError] = useState(null);

  const showError = (message) => {
    setGlobalError(message);
  };

  const clearError = () => {
    setGlobalError(null);
  };

  return (
    <ErrorContext.Provider value={{ globalError, showError, clearError }}>
      {children}
    </ErrorContext.Provider>
  );
};

export const useError = () => useContext(ErrorContext);